import React from "react";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  footer: {
    marginTop: 12,
    // marginBottom: 36,
    [theme.breakpoints.down("md")]: {
      paddingLeft: 20,
      paddingRight: 20,
    },
  },
  buttonBack: {
    width: 432,
    height: 78,
    marginBottom: 20,
    fontSize: 20,
    backgroundColor: "#ffffff",
    "&:hover": {
      backgroundColor: "#ffffff",
    },
    [theme.breakpoints.down("md")]: {
      width: "calc(50% - 20px)",
      height: 58,
      fontSize: 18,
    },
    [theme.breakpoints.down("sm")]: {
      width: "48%",
      height: 58,
      fontSize: 18,
    },
  },
  button: {
    width: 432,
    height: 78,
    marginBottom: 20,
    fontSize: 20,
    [theme.breakpoints.down("md")]: {
      width: "calc(50% - 20px)",
      height: 58,
      fontSize: 18,
    },
    [theme.breakpoints.down("sm")]: {
      width: "calc(50% - 4px)",
      height: 58,
      fontSize: 18,
    },
  },
}));
const CancerTwoBuFooter = ({ name1, name2, onClick1, onClick2 }) => {
  const classes = useStyles();
  return (
    <Grid
      container
      justify="space-between"
      alignItems="center"
      className={classes.footer}
    >
      <Button
        onClick={() => onClick1(0)}
        variant="outlined"
        color="primary"
        className={classes.buttonBack}
      >
        {name1}
      </Button>
      <Button
        onClick={() => onClick2()}
        variant="contained"
        color="primary"
        className={classes.button}
      >
        {name2}
      </Button>
    </Grid>
  );
};

export default CancerTwoBuFooter;
